import { Component } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RegisterComponent } from '../../Home/register/register';

@Component({
  selector: 'app-sales-hero',
  standalone: true,
  imports: [CommonModule, RegisterComponent],
  templateUrl: './sales-hero.html',
  styleUrls: ['./sales-hero.css'],
})
export class SalesHeroComponent {
  showRegister = false;
  salesApp = [{ name: 'Sales', image: 'images/webps/sales.svg' }];
}
